import { createSelector } from 'reselect';

import { getDeviceType } from '@travel/traveler-core/utils';

import type { RootState } from 'typesafe-actions';

export const getUserAgent = (state: RootState) => {
  if (state && state.userAgent) {
    return state.userAgent.userAgent;
  } else {
    return null;
  }
};

export const getSsrDeviceType = createSelector(getUserAgent, getDeviceType);
